import * as Sentry from '@sentry/browser';
import constants from '../constants';

const SentryInit = () => {
  Sentry.init({
    dsn: constants.SENTRY_DSN,
    environment: process.env.ENV,
    ignoreErrors: ['Email In Use', 'invalid_credentials'],
  });

  Sentry.captureMessage('Deprecation notice - Desktop App Beta');
};
// should have been called before using it here
// ideally before even rendering your react app

export default SentryInit;
